import { useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import SkillsSection from "@/pages/home/components/SkillsSection";
import DatingSection from "@/pages/home/components/DatingSection";
import StagesSection from "@/pages/home/components/StagesSection";
import TopicsSection from "@/pages/home/components/TopicsSection";
import ConsultSection from "@/pages/home/components/ConsultSection";
import StoriesSection from "@/pages/home/components/StoriesSection";
import ArticlesSection from "@/pages/home/components/ArticlesSection";
import ValuesSection from "@/pages/home/components/ValuesSection";
import CtaSection from "@/pages/home/components/CtaSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("全部");

  const handlePickTag = (category: string) => {
    setActiveCategory(category);
    document.getElementById("articles")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero onPickTag={handlePickTag} />
        <SkillsSection />
        <DatingSection />
        <StagesSection />
        <TopicsSection />
        <ConsultSection />
        <StoriesSection />
        <ArticlesSection activeCategory={activeCategory} onCategoryChange={setActiveCategory} />
        <ValuesSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}